import { render, staticRenderFns } from "./Matcher.vue?vue&type=template&id=52e12d36"
import script from "./Matcher.vue?vue&type=script&lang=js"
export * from "./Matcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports